import styled from 'styled-components';

import { Box } from '~/components/Box';

export const Body = styled(Box)`
  overflow-y: auto;
`;
try {
    // @ts-ignore
    Body.displayName = "Body";
    // @ts-ignore
    Body.__docgenInfo = { "description": "", "displayName": "Body", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Modal/Body/index.tsx#Body"] = { docgenInfo: Body.__docgenInfo, name: "Body", path: "src/components/Modal/Body/index.tsx#Body" };
}
catch (__react_docgen_typescript_loader_error) { }